@import "stylesheets/sdx/utilities/screenreaders";

.component {
  sdx-accordion-item-header {
    &:hover {
      span {
        color: $color-link--active;
      }
    }

    span {
      color: $color-link;
      transition: color 200ms $button-easing;
    }
  }
}

.component.sdx--dark-theme {
  sdx-accordion-item-header {
    &:hover {
      span {
        color: $color-int-blue2-dark-theme--active;
      }
    }

    span {
      color: $color-int-blue2-dark-theme;
    }
  }
}
